import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

// import "./styles/OrdersCta.module.scss";

const TwoCtaSlice = ({
  doc: { primary: { dark_theme = "", background_color = "" } = {}, items } = {},
  StartOrderBtn,
  backgroundColor = "",
}) => (
  <div
    className={`orders-block prismic-slice ${dark_theme}`}
    style={{ background: background_color || backgroundColor }}
  >
    <div className="container-fluid orders-block-container container-width">
      <div className="row">
        {items?.map(
          ({
            heading,
            sub_heading,
            text,
            link_text,
            link,
            dark_link,
            image,
            start_an_order_button_flag = false,
          }) => (
            <div className="col-md-6 text-center orders-column">
              <div className="orders-column-content-block">
                {checkContentPresence(heading) && (
                  <div className="sns-h5 text-a1 font-weight-bold text-uppercase block-top-text same-size-title">
                    {textResolver(heading)}
                  </div>
                )}
                {checkContentPresence(sub_heading) && (
                  <div className="mt-2 mt-md-3 mt-2xl-3 sns-h3 text-theme-primary order-block-title same-size-title">
                    {textResolver(sub_heading)}
                  </div>
                )}

                {checkContentPresence(text) && (
                  <div className="mt-2 mt-md-3 mt-2xl-3 px-5 px-2xl-5 sns-h5 order-block-description">
                    {textResolver(text)}
                  </div>
                )}
                {start_an_order_button_flag && StartOrderBtn && (
                  <div className="mt-3 mt-md-5 mt-2xl-5 buttons-row">
                    <StartOrderBtn className="button btn d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing button-program-green">
                      Send A Treat
                    </StartOrderBtn>
                  </div>
                )}
                {link?.url && (
                  <div className="mt-3 mt-md-5 mt-2xl-5 buttons-row">
                    <PrismicLinkTag
                      urlText={link_text}
                      url={link?.url}
                      target={link?.target}
                      className={`button btn d-inline-block font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing ${
                        dark_link ? "button-program-green" : "button-program-outline-green"
                      }`}
                    />
                  </div>
                )}
              </div>
              {image?.url && (
                <PrismicImgix
                  alt={image.alt}
                  src={image.url}
                  className="orders-block-image"
                  desktop="840px"
                  mobile="375px"
                  tablet="400px"
                  largeDisplay="2400px"
                />
              )}
            </div>
          )
        )}
      </div>
    </div>
  </div>
);

export default TwoCtaSlice;
